// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__brCxY","head":"ProcedureTableInfo_head__2yjDJ"};